/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

import {
  JOB_LIST,
  JOB_DETAIL,
  UPDATE_STATE,
  UPDATE_BULK_COPY_CHECKBOX_STATE,
  INIT_JOB_LIST,
  INIT_JOB_ID_LIST,
} from './action-types';

export function getSelectedList(payload, params) {
  return {
    type: JOB_LIST,
    payload,
    params
  }
}

export function getDetail(payload) {
  return {
    type: JOB_DETAIL,
    payload,
  }
}

export function updateStateJobs(payload) {
  return {
    type: UPDATE_STATE,
    payload,
  }
}

export function updateBulkCopyCheckboxState(payload) {
  return {
    type: UPDATE_BULK_COPY_CHECKBOX_STATE,
    payload,
  }
}

export function initSelectedList(payload) {
  return {
    type: INIT_JOB_LIST,
    payload,
  }
}

export function initSelectedIdList(payload) {
  return {
    type: INIT_JOB_ID_LIST,
    payload,
  }
}
